// extracted by mini-css-extract-plugin
export default {"root":"AddSc_root__MwtyD"};